import React from 'react';
import { Box, FieldStack, InputField, Link, Tooltip } from 'bumbag';
import { Field } from 'formik';

import validate, { isRequired, isValidDate, isValidEmailAsync, isValidMobile } from '@medipass/utils/validate-form';
type Props = {
  isEmailOptional?: boolean;
  isMobileOptional?: boolean;
};

const noop = () => undefined;

const MemberDetailsFields = ({ isEmailOptional, isMobileOptional }: Props) => (
  <FieldStack>
    <FieldStack orientation="horizontal">
      <Field
        component={InputField.Formik}
        name="firstName"
        label="First name"
        inputProps={{
          autoComplete: 'given-name',
        }}
        validate={validate(isRequired)}
      />
      <Field
        component={InputField.Formik}
        name="lastName"
        label="Last name"
        inputProps={{
          autoComplete: 'family-name',
        }}
        validate={validate(isRequired)}
      />
    </FieldStack>
    <Field
      component={InputField.Formik}
      hint={
        <Link fontSize="150">
          <Tooltip
            content="We require your date of birth to ensure we can correctly match you to your existing records with health care
            providers and funders."
            width="350px"
          >
            <Box>Why do we need this?</Box>
          </Tooltip>
        </Link>
      }
      name="dob"
      label="Date of birth (DD/MM/YYYY)"
      mask="99/99/9999"
      inputProps={{
        autoComplete: 'dob',
        type: 'tel',
      }}
      validate={validate(isRequired, isValidDate)}
    />
    <Field
      component={InputField.Formik}
      name="email"
      label={`Email address ${isEmailOptional ? '(optional)' : ''}`}
      inputProps={{
        autoComplete: 'email',
        type: 'email',
      }}
      validate={validate(isEmailOptional ? noop : isRequired, isValidEmailAsync)}
    />
    <Field
      component={InputField.Formik}
      name="mobile"
      label={`Mobile number ${isMobileOptional ? '(optional)' : ''}`}
      inputProps={{
        autoComplete: 'tel-national',
        type: 'tel',
      }}
      validate={validate(isMobileOptional ? noop : isRequired, isValidMobile)}
    />
  </FieldStack>
);

MemberDetailsFields.defaultProps = {
  isEmailOptional: false,
  isMobileOptional: false,
};
export default MemberDetailsFields;
